<app-dashboard-header></app-dashboard-header>

<main>
  <div class="container">
    <form [formGroup]="updateForm" enctype="multipart/form-data">
      <div class="form-group">
        <label>رقــم الحلقة</label>
        <input
          formControlName="sessionNumber"
          [class.is-invalid]="sessionNumber.invalid && sessionNumber.touched"
          type="text"
          class="form-control"
        />
        <div
          *ngIf="
            sessionNumber.errors &&
            sessionNumber.invalid && sessionNumber.touched
          "
        >
          <small class="text-danger" *ngIf="sessionNumber.errors?.required">
            رقــم الحلقة مطلوب
          </small>
        </div>
      </div>
      <!--   <div class="form-group">
                    <label>Image</label>
                    <input formControlName="image" type="text" class="form-control" />
                </div> -->
      
      <div class="form-group">
        <label>المجموعة</label>
        <select class="custom-select" formControlName="classId">
          <option *ngFor="let class of classes" value="{{ class._id }}">
            {{ class.Number }}
          </option>
        </select>
      </div>
      
      <div class="form-group">
        <label>بداية الوقـــت</label>
        <input formControlName="startTime" type="datetime-local"  class="form-control" />
      </div>
      <div class="form-group">
        <label>نهاية الوقـــت</label>
        <input formControlName="endTime" type="datetime-local"  class="form-control" />
      </div>

      <input
        type="submit"
        class="update btn btn-primary mt-2"
        value="تعديــــل"
        (click)="update()"
      />
    </form>
  </div>
</main>

<app-dashboard-footer></app-dashboard-footer>
